var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('router-view'),_c('BaseSnackbar',{attrs:{"color":_vm.snackBarColor,"message":_vm.snackbarMessage,"elevation":0},model:{value:(_vm.showToastMessage),callback:function ($$v) {_vm.showToastMessage=$$v},expression:"showToastMessage"}}),_c('BaseLoader',{attrs:{"isLoader":_vm.showLoader}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }